const postcodes = {
    baseUrl: 'https://api.postcodes.io/postcodes',
}

export default postcodes



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/config/postcodes.ts